import { DocumentationLegacyPageAssetType } from "../../enums/SDKDocumentationLegacyPageAssetType";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyItemHeader {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        this.backgroundImageAssetUrl =
            (_c = (_a = model.backgroundImageAssetUrl) !== null && _a !== void 0 ? _a : (_b = model.backgroundImageAsset) === null || _b === void 0 ? void 0 : _b.url) !== null && _c !== void 0 ? _c : null;
        this.backgroundImageAssetId =
            (_f = (_d = model.backgroundImageAssetId) !== null && _d !== void 0 ? _d : (_e = model.backgroundImageAsset) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : null;
        this.backgroundImageAssetType = (_h = (_g = model.backgroundImageAsset) === null || _g === void 0 ? void 0 : _g.type) !== null && _h !== void 0 ? _h : null;
        if (this.backgroundImageAssetType &&
            ((_j = model.backgroundImageAsset) === null || _j === void 0 ? void 0 : _j.figmaFrame)) {
            this.backgroundImageSourceId =
                (_m = (_l = (_k = model.backgroundImageAsset) === null || _k === void 0 ? void 0 : _k.figmaFrame) === null || _l === void 0 ? void 0 : _l.sourceId) !== null && _m !== void 0 ? _m : null;
            this.backgroundImagePersistentId =
                (_q = (_p = (_o = model.backgroundImageAsset) === null || _o === void 0 ? void 0 : _o.figmaFrame) === null || _p === void 0 ? void 0 : _p.persistentId) !== null && _q !== void 0 ? _q : null;
            this.backgroundImageSourceFrameId =
                (_t = (_s = (_r = model.backgroundImageAsset) === null || _r === void 0 ? void 0 : _r.figmaFrame) === null || _s === void 0 ? void 0 : _s.sourceFrameId) !== null && _t !== void 0 ? _t : null;
        }
        this.backgroundImageScaleType = model.backgroundImageScaleType;
        this.description = model.description;
        this.alignment = model.alignment;
        this.foregroundColor = (_u = model.foregroundColor) !== null && _u !== void 0 ? _u : null;
        this.backgroundColor = (_v = model.backgroundColor) !== null && _v !== void 0 ? _v : null;
        this.showBackgroundOverlay = model.showBackgroundOverlay;
        this.showCoverText = model.showCoverText;
        this.minHeight = model.minHeight;
    }
    toWriteModel() {
        let model = {
            description: this.description,
            alignment: this.alignment,
            // @ts-expect-error TS(2322): Type 'ColorTokenRemoteData | null' is not assignab... Remove this comment to see the full error message
            foregroundColor: this.foregroundColor,
            // @ts-expect-error TS(2322): Type 'ColorTokenRemoteData | null' is not assignab... Remove this comment to see the full error message
            backgroundColor: this.backgroundColor,
            // @ts-expect-error TS(2322): Type '{ id: string; url: string | null; type: Docu... Remove this comment to see the full error message
            backgroundImageAsset: this.backgroundImageAssetId
                ? {
                    id: this.backgroundImageAssetId,
                    url: this.backgroundImageAssetUrl,
                    type: this.backgroundImageAssetType,
                }
                : undefined,
            backgroundImageScaleType: this.backgroundImageScaleType,
            showBackgroundOverlay: this.showBackgroundOverlay,
            showCoverText: this.showCoverText,
            minHeight: this.minHeight,
        };
        if (this.backgroundImageAssetType ===
            DocumentationLegacyPageAssetType.figmaFrame &&
            model.backgroundImageAsset) {
            model = Object.assign(Object.assign({}, model), { backgroundImageAsset: Object.assign(Object.assign({}, model.backgroundImageAsset), { figmaFrame: {
                        // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
                        id: this.backgroundImageAssetId,
                        // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
                        sourceId: this.backgroundImageSourceId,
                        // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
                        persistentId: this.backgroundImagePersistentId,
                        // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
                        sourceFrameId: this.backgroundImageSourceFrameId,
                    } }) });
        }
        return model;
    }
}
